import { SERVER_ADDRESSES } from "../config/serverAddressesConfig";

export default function getDocumentUrl(documentId: number, host: "WEB" | "BITRIX"): string {
  return `${SERVER_ADDRESSES.DOC_API}/${documentId}${host === "BITRIX" ? "?initiator=Bitrix" : ""}`;
}
